var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{class:_vm.classes,style:(_vm.styling),attrs:{"viewBox":_vm.viewBox,"fill":_vm.fill}},[_c('use',{attrs:{"xlink:href":'/img/icons.svg#' + _vm.icon + '-icon'}})])}
var staticRenderFns = []

export { render, staticRenderFns }